import partnersRoutes from './crm/partners/index.routes'
import interactionsRoutes from './crm/interactions/index.routes'
import systemMasterDataRoutes from './system/master-data/index.routes'
import newsletterMasterDataRoutes from './newsletter/master-data/index.routes'
import systemRoutes from './system/system/index.routes'
import newsletterRoutes from './newsletter/newsletter/index.routes'
import authRoutes from './system/auth/index.routes'
import deploymentRoutes from "./deployment/deployment.routes";

export default [
    {
        // =========================
        // HOME AFTER LOGIN
        // =========================
        path: '/',
        name: 'home',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.home').ucFirst();
            },
        },
        component: () => import('@/views/layouts/main.vue'),
        children: [
            {
                path: 'subordinates',
                name: 'subordinates',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.subordinates').ucFirst();
                    },
                },
                component: () => import('@/views/pages/users/subordinates-dashboard.vue')
            },
            {
                path: 'reports',
                name: 'reports',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.reports').ucFirst();
                    },
                },
                component: () => import('@/views/pages/reports/dashboard.vue')
            },
            {
                path: 'partners',
                name: 'partners',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.partners').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                children: partnersRoutes
            },
            {
                path: 'interactions',
                name: 'personal-interactions',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: ['modules.crm'],
                    translate: (t) => {
                        return t('menu_points.interactions').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'my-interactions' },
                children: interactionsRoutes
            },
            {
                path: 'newsletters',
                name: 'newsletters',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.newsletters').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'newsletters-list'},
                children: newsletterRoutes
            },
            ...deploymentRoutes,
            {
                path: 'master-data',
                name: 'master-data',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.master_data').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                children: [...systemMasterDataRoutes, ...newsletterMasterDataRoutes]
            },
            {
                path: 'system',
                name: 'system',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.system').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                children: [...systemRoutes]
            }
        ]
    },
    {
        path: '/auth',
        name: 'auth',
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        children: authRoutes
    }
];